import { gql } from '@apollo/client';
export const MUTATION = gql `
  mutation CancelApprovalRequest($approvalId: UUID!, $input: CancelApprovalRequestInput) {
    cancelApprovalRequest(id: $approvalId, input: $input) {
      id
    }
  }
`;
